<template>
  <div>
    <input ref="input" type="hidden" :value="value" :name="id" />
    <!-- <div
      v-for="(opt, index) in options"
      :key="index"
      :class="['tile', {'tile-inline': inline}, isSelected(opt, index)]"
      :style="!inline ? `width: ${Math.floor(100 / (cols || 1))}%` : ''"
    > -->
    <div
      v-for="(opt, index) in options"
      :key="index"
      :class="['tile', {'tile-inline': inline}, {'selected': isSelected(opt, index)}]"
    >
      <label :for="optionName(id, index)" v-on:click="selectTile(opt, index)">
        <div>
          <img v-if="opt.imageUrl"
            :src="opt.imageUrl"
            :style="imageStyle"
          />
        </div>
        <div v-html="$t(opt.label)"></div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TileFiled',
  props: {
    id: String,
    options: Array,
    value: [Number, String],
    height: String,
    width: String,
    inline: Boolean,
    required: Boolean,
    disabled: Boolean,
  },

  computed: {
    imageStyle() {
      if (this.height && !this.width) {
        return `height: ${this.height}; max-width: initial`;
      }
      if (!this.height && this.width) {
        return `max-height: initial; width: ${this.width}`;
      }
      return `max-height: ${this.height || '100px'}; max-width: ${this.width || 'initial'}`
    }
  },

  methods: {
    isSelected(opt, index) {
      return this.value === (opt.value == null ? index : opt.value);
    },
    optionName(name, index) {
      return 'opt_' + name + '_ ' + index;
    },
    selectTile(opt, index) {
      if (this.disabled) {
        return ;
      }

      let value = opt.value == null ? index : opt.value;

      this.$emit('input', value);
    },
  }
}
</script>

<style scoped>
  .tile.selected {
    background: #eee;
  }
  .tile-inline {
    display: inline-block;
  }
  .tile {
    text-align: center;
    cursor: pointer;
    padding: 8px;
    display: inline-block;
  }
  .tile * {
    cursor: pointer;
  }

  .tile img {
    display: inline-block;
  }
</style>
